import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { AvoTrackingService } from "@bca-core/services/avo-tracking.service";
import { RouterService } from "@bca-core/services/router.service";
import { UIService } from "@bca-core/services/ui.service";
import * as receiptActions from "@bca-receipt/store/receipt.actions";
import { Route } from "@bca-shared/models/_enums";
import { IActionCode } from "@bca-shared/models/action-code";
import { ICompany } from "@bca-shared/models/company";
import { IMessage } from "@bca-shared/models/message";
import {
  AvoEventTypes,
  ButtonType,
} from "@bca-shared/utils/avo/avo-event-details.models";
import { AvoService } from "@bca-shared/utils/avo/avo.service";
import * as appActions from "@bca-store/app.actions";
import { IAction } from "@bca-store/models/action";
import { createAction } from "@bca-store/models/action-creator";
import { IRootState } from "@bca-store/store.reducers";
import * as userDataActions from "@bca-user-data/store/user-data.actions";
import { select, Store } from "@ngrx/store";
import { BehaviorSubject, Observable } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
  selector: "bca-verify",
  templateUrl: "verify.component.html",
  styleUrls: ["verify.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyComponent {
  company$: Observable<ICompany>;
  allowNewProduct$: BehaviorSubject<boolean>;
  actionCode$: Observable<IActionCode>;
  previousDestination = "https://www.ns.nl/businesscardaanvragen/bedrijf";
  addExtraCardDestination = "https://www.ns.nl/businesscardaanvragen";

  constructor(
    private _store$: Store<IRootState>,
    private _uiService: UIService,
    private _routerService: RouterService,
    private _avoService: AvoService,
    private _avoTrackingService: AvoTrackingService,
  ) {
    this.company$ = this._store$.pipe(
      select(({ receipt }) => receipt.company),
      filter((company) => company != null),
    );
    this.allowNewProduct$ = this._uiService.allowNewProduct$;
    this.actionCode$ = this._store$.pipe(
      select(({ receipt }) => receipt.actionCode),
    );
  }

  previousRoute(): void {
    this.handleAvoEvent("link_click", this.previousDestination);
    this._store$.dispatch(this._createAction(new appActions.PreviousRoute()));
  }

  addNewProduct(): void {
    this.handleAvoEvent(
      "add_extra_card_link_click",
      this.addExtraCardDestination,
    );
    this._store$.dispatch(
      this._createAction(new userDataActions.SelectProduct(null)),
    );
    this._routerService.navigateTo(Route.COMPOSE);
  }

  nextRoute(): void {
    this.handleAvoEvent("button_click");
    this._store$.dispatch(
      this._createAction(
        new receiptActions.SetVerifiedStatus({ verified: true }),
      ),
    );
    this._store$.dispatch(this._createAction(new appActions.NextRoute()));
  }

  onActionCodeAdd(actionCode: IActionCode): void {
    this._store$.dispatch(
      this._createAction(new receiptActions.AddActionCode(actionCode)),
    );
  }

  onActionCodeDelete(): void {
    this._store$.dispatch(
      this._createAction(new receiptActions.DeleteActionCode()),
    );
  }

  onActionCodeError(message: IMessage): void {
    this._store$.dispatch(
      this._createAction(new appActions.SetMessage(message)),
    );
  }

  onEditCompany(): void {
    this._routerService.navigateTo(Route.COMPANY_DATA);
  }

  private _createAction(action: IAction): IAction {
    return createAction(action, VerifyComponent);
  }

  private handleAvoEvent(eventType: AvoEventTypes, destination?: string) {
    switch (eventType) {
      case "button_click":
        const props = {
          uniqueName: "verify_your_order",
          description: "continueToPayment",
          clickDestination:
            "https://www.ns.nl/businesscardaanvragen/bevestiging",
          clickText: "Verder naar betalen",
          data: undefined,
        };
        const trackingData = this._avoTrackingService.trackButtonClick(props);
  
        this._avoService.buttonClick(trackingData);
        break;

      case "link_click":
        this._avoTrackingService.trackBackLinkClick(destination);

        break;
      case "add_extra_card_link_click":
        this._avoTrackingService.trackAddExtraCardLinkClick(destination);

        break;
      default:
        console.warn(`Unhandled event type: ${eventType}`);
    }
  }
}
